export const PRODUCTION_ENDPOINT = 'https://us-central1-campus-recruitment-test.cloudfunctions.net/api'
export const DEVELOPMENT_ENDPOINT = 'https://us-central1-campus-recruitment-test.cloudfunctions.net/api'
export const TEST_ENDPOINT = 'https://us-central1-campus-recruitment-test.cloudfunctions.net/api'



// WEBPACK FOOTER //
// ./src/constants/endpoints.js